/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { toUpper } from 'lodash'
import { useIntl } from 'react-intl'
import FormTextareaField, {
  FormTextareaFieldProps
} from '../../../../client/js/components/form/fields/FormTextareaField'

function AddressField (props: FormTextareaFieldProps) {
  const intl = useIntl()
  const { name = 'address', ...others } = props
  return (
    <FormTextareaField
      label={intl.formatMessage({
        id: 'address',
        defaultMessage: 'Adresse postale'
      })}
      name={name}
      parser={toUpper}
      {...others}
    />
  )
}

export default AddressField
